import {Search} from 'lucide-react';
import {PhoneHQSortHeader, PhoneHQAvatar, PhoneHQIconAvatar, PhoneHQButton, PhoneHQGlyph, PhoneHQInput, PhoneHQLoader, PhoneHQTooltip} from 'ch3-ui-lib';
import {Link, useNavigate} from "react-router-dom";
import {Msisdn, MsisdnSelectItem} from "../../store/features/Msisdns/msisdnService.ts";
import {Group, GroupListItem} from "../../store/features/groups/groupsService.ts";
import {UserListItem} from "../../store/features/Users/userService.ts";
import {useUsersWithStatuses} from "../../hooks/useUsersWithStatuses.ts";
import {getUserStatus} from "../../utilis/getStatus.ts";
import {useState} from "react";
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {buildQueryParams} from "../../utilis/buildQueryParams.ts";
import CallFiltersPanel from "../../components/Filters/CallFiltersPanel.tsx";
import noTeamMemberYet from "../../assets/no-team-member-yet.svg";
import noGroupsIcon from "../../assets/empty-groups.svg";

export default function TeamListAdmin() {
    const isMobile = useMediaQuery('(max-width: 960px)');
    const [phrase, setPhrase] = useState<string>('');
    const [phoneNumbersFilter, setPhoneNumbersFilter] = useState<MsisdnSelectItem[]>([]);
    const [groupsFilter, setGroupsFilter] = useState<GroupListItem[]>([]);
    const [roleFilter, setRoleFilter] = useState<string[]>([]);
    const [statusFilter, setStatusFilter] = useState<string[]>(['ACTIVE']);

    const [order, setOrder] = useState<'ASC' | 'DESC'>('ASC');

    const effectiveStatusFilter = (statusFilter.length === 0 || statusFilter.length === 2) ? [] : statusFilter;

    const usersQuery = buildQueryParams({
        phoneNumbers: phoneNumbersFilter.map((item) => item.msisdnId),
        groups: groupsFilter.map((item) => item.groupId),
        roles: roleFilter,
        status: effectiveStatusFilter,
        phrase: phrase,
        order: order,
    });

    const {data: usersData, isLoading} = useUsersWithStatuses(usersQuery);

    const navigate = useNavigate();

    const filterHandlers = {
        onGroupsChange: (groups: GroupListItem[]) => {
            setGroupsFilter(groups);
        },
        onPhoneNumbersChange: (phoneNumbers: MsisdnSelectItem[]) => {
            setPhoneNumbersFilter(phoneNumbers);
        },
        onRolesChange: (roles: string[]) => {
            setRoleFilter(roles);
        },
        handleContactSelect: (contact: any) => {
            console.log('Contact selected:', contact);
        },
        handleUserSelect: (user: any) => {
            console.log('User selected:', user);
        },
        handleDateSelect: (dateRange: any) => {
            console.log('Date range selected:', dateRange);
        },
        onStatusChange: (status: string[]) => {
            setStatusFilter(status);
        },
    };

    const handleDataChange = (value: string) => {
        setPhrase(value);
    };
    return (
        <>
            {isLoading && (
                <div className={`flex w-full`}>
                    <PhoneHQLoader/>
                </div>
            )}
            <div className='w-full'>
                <div>
                    <div className={`flex justify-between items-center py-3 px-8 no-wrap border-b border-line`}>
                        <div className="flex gap-2">
                            <CallFiltersPanel
                                admin={true}
                                items={['PHONE_NUMBERS', 'GROUPS', 'ROLES', 'STATUS']}
                                handlers={filterHandlers}
                                selectedGroups={groupsFilter}
                                selectedPhoneNumbers={phoneNumbersFilter}
                                selectedRoles={roleFilter}
                                selectedStatus={statusFilter}
                            />
                        </div>
                        <PhoneHQInput
                            value={phrase}
                           
                            placeholder={'Search'}
                            containerClassName={`${isMobile ? '' : 'min-w-[375px]'}`}
                            prefixIcon={<Search size={16} aria-hidden="true" className="!p-0"/>}
                            onChange={({target: {value}}) => handleDataChange(value)} onClear={() => handleDataChange('')}/>
                    </div>

                    <div className={`h-[calc(100vh-61px-var(--header-height))] overflow-y-auto`}>
                        <div className={'w-full ' + 'bg-surface'}>
                            <table className={`w-full border-b ` + 'border-line'}>
                                { !!usersData?.users.length &&
                                    <thead>
                                    <tr className={`border-b ` + 'border-line'}>
                                        <th className='pl-8 py-3 w-full h-[60px]'>
                                            <PhoneHQSortHeader label={"Name"} propertyName='NAME' onSort={setOrder}/>
                                        </th>
                                        <th className='lg:w-[200px] 2xl:min-w-[300px]'>
                                            <PhoneHQSortHeader label={"Groups"}/>
                                        </th>
                                        <th className='min-w-[200px]'>
                                            <PhoneHQSortHeader label={"Phone numbers"}/>
                                        </th>
                                    </tr>

                                    </thead>
                                }

                                    <tbody>
                                    {usersData?.users?.map((user: UserListItem) => (
                                        <tr
                                            onClick={() => navigate(`/admin/team-details/${user.userId}`)}
                                            className={`border-t border-line hover:bg-surface-muted cursor-pointer ${
                                                user.status === 'DELETED' ? 'bg-surface-muted !text-ink-muted' : 'bg-surface'
                                            }`}
                                            key={user.userId}
                                        >
                                            <td className='flex gap-3 font-semibold items-center pl-8 py-4 h-[76px]'>
                                                <PhoneHQAvatar src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} status={user.status === 'DELETED' ? false : getUserStatus(user)} size="40px"/>
                                                <div>
                                                    <div className={`w-[200px] truncate text-sm font-medium`}>
                                                        {user.firstName + ' ' + user.lastName}
                                                    </div>
                                                    <div
                                                        className={`w-[200px] truncate text-sm flex font-normal capitalize`}>
                                                        <div>{user?.role?.toLowerCase()}</div>
                                                        {user.status === 'DELETED' &&
                                                        <div className="ml-1">{' (Deactivated)'}</div>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                {user?.groups && (
                                                    <div
                                                        className="min-w-[180px] max-w-[200px] justify-start items-center flex mr-4">
                                                        {user.groups.slice(0, 6).map((item: Group, index: number) => (
                                                            <PhoneHQTooltip key={index} content={`${item.name}`} align='start'><div
                                                                        style={{right: `${index * 10}px`}}
                                                                        className={`relative`}
                                                                    >
                                                                        <PhoneHQIconAvatar icon={item.icon} color={user.status === 'DELETED' ? 'disabled' : item.iconColor} size="32px"/>
                                                                    </div></PhoneHQTooltip>
                                                        ))}
                                                        {user?.groups?.length > 6 && (
                                                            <div
                                                                style={{right: `60px`}}
                                                                className={`relative`}
                                                            >
                                                                <PhoneHQAvatar name={`+ ${user.groups.length - 6}`} size="32px"/>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </td>

                                            <td>
                                                <div className={'flex min-w-[350px]'}>
                                                    {user.phoneNumbers.slice(0, 2).map((number: Msisdn, index: number) => (
                                                        <div key={index} className={'flex mr-4 items-center'}>
                                                            <div className='text-xl mr-2'>
                                                                <PhoneHQIconAvatar className='!text-base' icon={number.icon} color={user.status === 'DELETED' ? 'disabled' : number.iconColor} size="20px"/>
                                                            </div>
                                                            <div className="max-w-[200px] text-sm truncate">
                                                                {number.label}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {user.phoneNumbers.length > 2 && (
                                                        <PhoneHQTooltip content={
                                                                <div className={'max-w-[360px] flex gap-3 flex-wrap'}>
                                                                    {user.phoneNumbers.slice(2).map((number: Msisdn, index: number) => (
                                                                        <div className={'flex items-center gap-1'}
                                                                             key={index}>
                                                                            <PhoneHQIconAvatar icon={number.icon} color={user.status === 'DELETED' ? 'disabled' : number.iconColor} size="32px"/>
                                                                            <span>{number.label}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            } align='start'><div
                                                                    className="text-ink-muted font-medium text-sm hover:bg-surface-muted px-3 py-1 rounded-sm">
                                                                    +{user.phoneNumbers.length - 2}
                                                                </div></PhoneHQTooltip>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                            </table>
                            {!usersData?.users.length  && (phoneNumbersFilter.length || groupsFilter.length || roleFilter.length || phrase ) &&
                                <div className={`flex text-center  justify-center  border-b ` + 'border-line'}>
                                    <div className='w-[450px]  m-14'>
                                        <div className='flex  justify-center w-full'>
                                            <img className='m-4' src={noGroupsIcon}/>
                                        </div>

                                        <h1 className='font-bold'>
                                            No user found
                                        </h1>





                                            <div className='mb-6 mt-2'>
                                                Check your spelling or try using different keywords.
                                                Not finding them? Add a new user.
                                            </div>

                                            <div className='flex justify-center '>
                                                <Link to={'/admin/team-details/new'}>
                                                    <PhoneHQButton size="lg" className='h-[56px]' phq-id='teamListAdmin-inviteNewBtn' ><PhoneHQGlyph name='add' size={16}/>Invite new team member</PhoneHQButton>
                                                </Link>

                                            </div>

                                    </div>

                                </div>

                            }
                            {!usersData?.users.length  && (!phoneNumbersFilter.length && !groupsFilter.length && !roleFilter.length && !phrase) &&
                                <div className={`flex text-center  justify-center  border-b ` + 'border-line'}>
                                    <div className='w-[450px]  m-14'>
                                        <div className='flex  justify-center w-full'>
                                            <img className='m-4' src={noTeamMemberYet}/>
                                        </div>

                                        <h1 className='font-bold'>
                                            No team member yet
                                        </h1>





                                        <div className='mb-6 mt-2'>
                                            Click below to add one now.
                                        </div>

                                        <div className='flex justify-center '>
                                            <Link to={'/admin/team-details/new'}>
                                                <PhoneHQButton size="lg" className='h-[56px]' phq-id='teamListAdmin-inviteNewNoMembersBtn' ><PhoneHQGlyph name='add' size={16}/>Invite new team member</PhoneHQButton>
                                            </Link>

                                        </div>

                                    </div>

                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}